module.exports = __webpack_public_path__ + "static/media/marlene_german.73e1b300.mp3";